import { useDispatch, useSelector } from 'react-redux';
import { InjectedPropsProvider } from '../../../Core/InjectedPropsContext';
import { getAdminProviderProps } from './providerProps';
import { actions } from '../../../../Data/ReduxViewModels/Admin';
import React, { useCallback } from 'react';

/**
 * The intention of this class is to apply common logic to all child components that should work consistently across
 * admin components that opt into consumption.
 */
let AdminInjectedPropsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const data = useSelector((s) => s.admin);
  const getProviderProps = useCallback(
    (consumerProps) =>
      getAdminProviderProps(consumerProps, {
        data,
        setValue: (opts) => {
          dispatch(actions.setValue(opts));
        },
        synchronise: () => {
          dispatch(actions.syncData());
        },
      }),
    [data, dispatch]
  );
  return <InjectedPropsProvider getProviderProps={getProviderProps}>{children}</InjectedPropsProvider>;
};

export { AdminInjectedPropsProvider };
export default AdminInjectedPropsProvider;
